import React, { useEffect, useState } from "react";
import API from "../api/axios"; // ✅ USE GLOBAL API
import "../styles/main.css";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  /* ================= FETCH USERS ================= */
  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      setError("");

      try {
        const res = await API.get("/users"); // ✅ CLEAN CALL

        console.log("👥 USERS:", res.data);

        // ✅ SAFE HANDLING
        setUsers(res.data.users || res.data || []);
      } catch (err) {
        console.error("❌ USERS ERROR:", err);

        if (err.response) {
          setError(err.response.data?.message || "Server error");
        } else if (err.request) {
          setError("Backend not reachable");
        } else {
          setError("Something went wrong");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  return (
    <div className="users-page">
      <h2>Users</h2>

      {loading && <p>Loading users...</p>}
      {error && <p className="error-msg">{error}</p>}

      {!loading && !error && (
        <table className="users-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Verified</th>
            </tr>
          </thead>
          <tbody>
            {users.length > 0 ? (
              users.map((u) => (
                <tr key={u._id}>
                  <td>{u._id}</td>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{u.phone}</td>
                  <td>{u.isVerified ? "Yes" : "No"}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">No users found</td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Users;